import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = import.meta.env.VITE_LOOKUPS_SERVICE_URL;

export const lookupsApi = createApi({
  reducerPath: 'lookupsApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
  }),
  endpoints: () => ({}),
});
